"use client";

import { useTranslations } from "next-intl";
import { useState } from "react";
import { ClaimClubDialog } from "./ClaimClubDialog";

interface ClaimClubSectionProps {
  clubId: string;
  clubName: string;
}

export function ClaimClubSection({ clubId, clubName }: ClaimClubSectionProps) {
  const t = useTranslations();
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <div className="bg-white rounded-xl p-6 border border-gray-200">
        <h3 className="text-xl font-bold text-foreground mb-2">
          {t("claimClub.cta")}
        </h3>
        <p className="text-foreground-secondary mb-6">
          {t("claimClub.prompt")}
        </p>
        <button
          type="button"
          onClick={() => setShowDialog(true)}
          className="w-full bg-foreground text-background font-semibold py-3 px-6 rounded-full hover:bg-foreground/90 transition-colors"
        >
          {t("claimClub.ctaButton")}
        </button>
      </div>

      <ClaimClubDialog
        open={showDialog}
        onOpenChange={setShowDialog}
        clubId={clubId}
        clubName={clubName}
      />
    </>
  );
}
